function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18 35.5c9.665 0 17.5-7.835 17.5-17.5S27.665.5 18 .5.5 8.335.5 18 8.335 35.5 18 35.5zm0-3C9.992 32.5 3.5 26.008 3.5 18S9.992 3.5 18 3.5 32.5 9.992 32.5 18 26.008 32.5 18 32.5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.512 30.037l20.525 19.817 2.084-2.158L28.596 27.88z"
});

function SvgIconSearch(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTAgNTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTE4IDM1LjVjOS42NjQ5ODMxIDAgMTcuNS03LjgzNTAxNjkgMTcuNS0xNy41IDAtOS42NjQ5ODMxMi03LjgzNTAxNjktMTcuNS0xNy41LTE3LjUtOS42NjQ5ODMxMiAwLTE3LjUgNy44MzUwMTY4OC0xNy41IDE3LjUgMCA5LjY2NDk4MzEgNy44MzUwMTY4OCAxNy41IDE3LjUgMTcuNXptMC0zYy04LjAwODEyODg3IDAtMTQuNS02LjQ5MTg3MTEtMTQuNS0xNC41IDAtOC4wMDgxMjg4NyA2LjQ5MTg3MTEzLTE0LjUgMTQuNS0xNC41IDguMDA4MTI4OSAwIDE0LjUgNi40OTE4NzExMyAxNC41IDE0LjUgMCA4LjAwODEyODktNi40OTE4NzExIDE0LjUtMTQuNSAxNC41eiIvPjxwYXRoIGQ9Im0yNi41MTIzMzkzIDMwLjAzNzIxMDQgMjAuNTI0ODcxMSAxOS44MTcxMTY5IDIuMDgzNzgzNi0yLjE1ODIwNDQtMjAuNTI0ODcxMS0xOS44MTcxMTY5eiIvPjwvc3ZnPg==";
export { SvgIconSearch as ReactComponent };